// @flow
import { useContext } from 'react';

import VerificationsContext from './VerificationsContext';


const useVerificationsDataContext = (): any => useContext(VerificationsContext);

export default useVerificationsDataContext;
